import { ListItemButton, styled } from '@mui/material';

interface TileStyledProps {
  $backgroundImage: string;
}

export const TileStyled = styled(ListItemButton)<TileStyledProps>(
  ({ theme, $backgroundImage }) => ({
    display: 'flex',
    alignItems: 'flex-end',
    background: `linear-gradient(0.15deg, rgba(33, 41, 53, 0.8) 0.14%, rgba(33, 41, 53, 0) 62.48%), url(${$backgroundImage}) center`,
    backgroundSize: 'cover',
    height: '15.6rem',
    color: theme.palette.common.white,
    boxShadow: theme.customShadow,
    borderRadius: theme.shape.borderRadius,

    '&:focus': {
      border: `0.2rem solid ${theme.palette.primary.main}`,
    },

    '&.Mui-disabled': {
      opacity: 1,
      backgroundColor: theme.palette.grey[200],
      color: theme.palette.grey[400],
    },

    [theme.breakpoints.down('lg')]: {
      flexBasis: 'calc(50% - 16px)',
    },
    [theme.breakpoints.up('lg')]: {
      width: 0,
    },
  })
);
